import _regeneratorRuntime from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var OidcMetadataClient =
/*#__PURE__*/
function () {
  function OidcMetadataClient(authority) {
    _classCallCheck(this, OidcMetadataClient);

    this.authority = authority;
  }

  _createClass(OidcMetadataClient, [{
    key: "getMetadata",
    value: function () {
      var _getMetadata = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {
                  issuer: this.authority,
                  authorization_endpoint: this.authority + "/connect/authorize",
                  token_endpoint: this.authority + "/connect/token",
                  userinfo_endpoint: this.authority + "/connect/userinfo",
                  end_session_endpoint: this.authority + "/connect/endsession"
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMetadata() {
        return _getMetadata.apply(this, arguments);
      }

      return getMetadata;
    }()
  }]);

  return OidcMetadataClient;
}();